import { render, staticRenderFns } from "./DailyFreeItem.vue?vue&type=template&id=31f96dbf&scoped=true"
import script from "./DailyFreeItem.vue?vue&type=script&lang=js"
export * from "./DailyFreeItem.vue?vue&type=script&lang=js"
import style0 from "./DailyFreeItem.vue?vue&type=style&index=0&id=31f96dbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f96dbf",
  null
  
)

export default component.exports